module.exports = {
  footerText: 'Copyright myorganda © 2020',
}
